import axios from 'axios';
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'
import getUsers from "./users_get";
import store from '../../../Store';

function _success(success) {
    return {type: 'DELETE_USER_SUCCESS', success}
}

function _error(error) {
    return {type: 'DELETE_USER_ERROR', error}
}

function _processing(processing) {
    return {type: 'DELETE_USER_PROCESSING', processing}
}

function deleteUser(id) {
    return (dispatch) => {

        dispatch(_processing(true));
        dispatch(_success(null));
        dispatch(_error(null));

        let config = {
            headers: {'Authorization': 'Bearer ' + loginToken()},
        };

        axios.delete(apiBaseUrl(`admin/${id}`), config)

            .then(res => {
                dispatch(_success(res));
                dispatch(_processing(false));
                handleSuccess(res);
                store.dispatch(getUsers());
            }).catch(error => {
            dispatch(_error(error));
            dispatch(_processing(false));
            handleError(error)

        });
    }
}

export default deleteUser;